import { createAction, createSlice, isAnyOf } from '@reduxjs/toolkit';
import { instrumentApi } from '../api/instrument.api';
import type { InstrumentState } from './model/state';

export const INITIALINSTRUMENT_STATE: InstrumentState = {
  instrumentFetching: null,
};

export const cleanupInstrument = createAction('cleanupInstrument');

export const instrumentSlice = createSlice({
  name: 'instrument',
  initialState: INITIALINSTRUMENT_STATE,

  reducers: {},

  extraReducers: (builder) => {
    const {
      endpoints: {
        getBondInstrument,
        getEquityInstrument,
        getAlternativeInstrument,
        getForwardInstrument,
        getOtherInstrument,
      },
    } = instrumentApi;

    builder.addCase(cleanupInstrument, (state) => {
      state.instrumentFetching = null;
    });

    builder.addMatcher(
      isAnyOf(
        getBondInstrument.matchPending,
        getEquityInstrument.matchPending,
        getAlternativeInstrument.matchPending,
        getForwardInstrument.matchPending,
        getOtherInstrument.matchPending,
      ),
      (state) => {
        state.instrumentFetching = { status: 'loading' };
      },
    );

    builder.addMatcher(isAnyOf(getBondInstrument.matchFulfilled), (state, action) => {
      state.instrumentFetching = { status: 'loaded', assetClassCode: 'BOND', ...action.payload };
    });

    builder.addMatcher(isAnyOf(getEquityInstrument.matchFulfilled), (state, action) => {
      state.instrumentFetching = { status: 'loaded', assetClassCode: 'EQUITY', ...action.payload };
    });

    builder.addMatcher(isAnyOf(getAlternativeInstrument.matchFulfilled), (state, action) => {
      state.instrumentFetching = {
        status: 'loaded',
        assetClassCode: 'ALTERNATIVE',
        ...action.payload,
      };
    });

    builder.addMatcher(isAnyOf(getForwardInstrument.matchFulfilled), (state, action) => {
      state.instrumentFetching = { status: 'loaded', assetClassCode: 'FORWARD', ...action.payload };
    });

    builder.addMatcher(isAnyOf(getOtherInstrument.matchFulfilled), (state, action) => {
      state.instrumentFetching = { status: 'loaded', assetClassCode: 'MISCELLANEOUS', ...action.payload };
    });

    builder.addMatcher(
      isAnyOf(
        getBondInstrument.matchRejected,
        getEquityInstrument.matchRejected,
        getAlternativeInstrument.matchRejected,
        getForwardInstrument.matchRejected,
        getOtherInstrument.matchRejected,
      ),
      (state, action) => {
        state.instrumentFetching = { status: 'loadingFailed', error: action.payload };
      },
    );
  },

  selectors: {
    instrumentFetching: (state) => state.instrumentFetching,
  },
});

export const instrumentActions = instrumentSlice.actions;

export const instrumentSelectors = instrumentSlice.selectors;
